import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { PageLoader } from '@/components/PageLoader';
import { useWelcomeModal } from '@/hooks/useWelcomeModal';
import { lazy, Suspense } from 'react';
import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import Landing from './Landing';

const WelcomeModal = lazy(() => import('@/components/WelcomeModal').then(m => ({ default: m.WelcomeModal })));

const Root = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { showWelcome, setShowWelcome } = useWelcomeModal();

  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <>
        {showWelcome && (
          <Suspense fallback={null}>
            <WelcomeModal open={showWelcome} onOpenChange={setShowWelcome} autoPlay={true} />
          </Suspense>
        )}
        <PageLoader />
      </>
    );
  }

  // Unauthenticated users see the landing page
  if (!user) {
    return (
      <RouteErrorBoundary groupName="Landing">
        <Suspense fallback={<PageLoader />}>
          <Landing />
        </Suspense>
      </RouteErrorBoundary>
    );
  }

  return <PageLoader />;
};

export default Root;
